// @ts-check

import { onDomReady } from '../../utils/dom';
import { ElementsBlocker } from '../../vendor/ElementsBlocker/Blockers';

const elementsBlockerFolder = 'files/theme/js/modules/elementsBlocker';

function initializeBlocker() {
    const privacyPolicy = document.querySelector('.privacy_policy .content_inside');

    if (privacyPolicy) {
        const youtubeSection = document.createElement('div');
        youtubeSection.id = 'youtube';

        const youtubeHeadline = Array.from(privacyPolicy.querySelectorAll('h3')).find((h3) =>
            h3.textContent?.includes('YouTube'),
        );

        if (youtubeHeadline) {
            youtubeHeadline.after(youtubeSection);
        }
    }

    const blockerDiv = document.createElement('div');
    blockerDiv.classList.add('yt-blocker');

    const youTubeVideos = document.querySelectorAll('.content-youtube iframe[data-src]');

    for (const video of youTubeVideos) {
        video.after(blockerDiv.cloneNode());
    }

    new ElementsBlocker('.yt-blocker', {
        button: {
            content: 'Akzeptieren & Inhalte laden',
        },
        logo: {
            source: `${elementsBlockerFolder}/icons/YouTubeLogo.svg`,
            width: 70,
            alt: 'YouTube Logo',
        },
        localStorage: {
            enabled: true,
            agreementWithdrawal: {
                placementSelector: '#youtube',
                position: 'after',
                reload: true,
                containerClass: ['agreement-withdrawal'],
                headline: {
                    element: 'h4',
                    content: 'Einwilligung',
                },
                message: {
                    content: 'Hier können Sie Ihre Einwilligung zum Laden der YouTube-Videos widerrufen.',
                },
                button: {
                    element: 'button',
                    content: 'YouTube Einwilligung widerrufen',
                },
            },
        },
        headline: {
            content: 'YouTube',
            element: 'h3',
        },
        message: {
            content:
                'Bitte klicken Sie auf Akzeptieren, um das Video anzuzeigen. Wir möchten Sie darauf hinweisen, dass durch den Start des YouTube-Videos eine Verbindung zu den Servern von YouTube hergestellt und Daten (z. B. die IP-Adresse) an YouTube übermittelt werden. Details in der <a target="_parent" href="datenschutz">Datenschutzerklärung</a>.',
        },
        caching: false,
        onSubmit: [
            () => {
                const iframes = document.querySelectorAll('.content-youtube iframe');

                for (const iframe of iframes) {
                    iframe.src = iframe.dataset.src;
                }

                const texts = document.querySelectorAll('.content-youtube .consent-withdrawal');

                for (const el of texts) {
                    el.classList.add('active');
                }
            },
        ],
    });
}

onDomReady(() => {
    initializeBlocker();
});
